<template>
  <!-- Customer History -->
  <div class="px-4 my-4 sm:px-6 lg:px-8">
    <ul
      class="grid grid-cols-1 gap-4 sm:gap-6 sm:grid-cols-2 md:grid-cols-4 mt-3"
    >
      <li class="relative col-span-1 flex shadow-sm rounded-md">
        <div
          class="flex-shrink-0 flex items-center justify-center w-16 bg-blue-600 text-white text-sm leading-5 font-medium rounded-l-md"
        >
          <icon
            set="outline"
            name="shopping-cart"
            class="flex-shrink-0 h-8 w-8 text-white"
          />
        </div>
        <div
          class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
        >
          <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
            <a
              href="#"
              class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
            >
              Orders
            </a>
            <p class="text-gray-500">
              {{ history.orderCount }}
            </p>
          </div>
        </div>
      </li>

      <li class="relative col-span-1 flex shadow-sm rounded-md">
        <div
          class="flex-shrink-0 flex items-center justify-center w-16 bg-green-400 text-white text-sm leading-5 font-medium rounded-l-md"
        >
          <icon
            set="outline"
            name="currency-dollar"
            class="flex-shrink-0 h-8 w-8 text-white"
          />
        </div>
        <div
          class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
        >
          <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
            <a
              href="#"
              class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
            >
              Revenue
            </a>
            <p class="text-gray-500">{{ history.revenue | currency }}</p>
          </div>
        </div>
      </li>

      <li class="relative col-span-1 flex shadow-sm rounded-md">
        <div
          class="flex-shrink-0 flex items-center justify-center w-16 bg-red-600 text-white text-sm leading-5 font-medium rounded-l-md"
        >
          <icon
            set="outline"
            name="receipt-refund"
            class="flex-shrink-0 h-8 w-8 text-white"
          />
        </div>
        <div
          class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
        >
          <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
            <a
              href="#"
              class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
            >
              Refunds
            </a>
            <p class="text-gray-500">-{{ history.refunds | currency }}</p>
          </div>
        </div>
      </li>

      <li class="relative col-span-1 flex shadow-sm rounded-md">
        <div
          class="flex-shrink-0 flex items-center justify-center w-16 bg-purple-600 text-white text-sm leading-5 font-medium rounded-l-md"
        >
          <icon
            set="outline"
            name="credit-card"
            class="flex-shrink-0 h-8 w-8 text-white"
          />
        </div>
        <div
          class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
        >
          <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
            <a
              href="#"
              class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
            >
              Credits
            </a>
            <p class="text-gray-500"> Coming Soon</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
/**
 * TODO
 */
import moneyFormatter from "@/mixins/moneyFormatter";

export default {
  name: "CustomerHistory",
  filters: {
    currency: moneyFormatter.format,
  },
  mixins: [moneyFormatter],
  data() {
    return {};
  },
  props: {
    history: {
      type: Object,
      default: () => {}
    }
  },
  created() {},
  components: {},
  computed: {},
  methods: {},
};
</script>
